import { Row } from 'antd';
import React from 'react';

import Slider from './Slider.style';

type SliderProps = React.ComponentProps<typeof Slider>;

const RangeSelector: React.FC<SliderProps> = (props) => (
    <Row style={{ width: '100%' }}>
        <div style={{ width: '100%' }}>
            <Slider {...props} range />
        </div>
    </Row>
);

export default RangeSelector;
export { SliderProps };
